import type { ProfileInDbWithApplications } from "@profile-service-types/profile-in-db-with-applications";
import { computed, type Ref } from "vue";
import type { GoogleAddress } from "../types/address";

const BLANK_ADDRESS: GoogleAddress = {
  street_address_1: "",
  city: "",
  state: "",
  postal_code: "",
  country: "",
};

export const useProfileAddresses = (profile: Ref<ProfileInDbWithApplications | undefined>) => {
  const currentAddress = computed<GoogleAddress>(() => {
    if (!profile.value) return BLANK_ADDRESS;
    return {
      street_address_1: profile.value.current_address_line_1 ?? "",
      city: profile.value.current_address_city ?? "",
      state: profile.value.current_address_state ?? "",
      country: profile.value.current_address_country_id ?? "",
      postal_code: profile.value.current_address_postal_code ?? "",
    };
  });

  const permanentAddress = computed<GoogleAddress>(() => {
    if (!profile.value) return BLANK_ADDRESS;
    return {
      street_address_1: profile.value.permanent_address_line_1 ?? "",
      city: profile.value.permanent_address_city ?? "",
      state: profile.value.permanent_address_state ?? "",
      country: profile.value.permanent_address_country_id ?? "",
      postal_code: profile.value.permanent_address_postal_code ?? "",
    };
  });

  const billingAddress = computed<GoogleAddress>(() => {
    if (!profile.value) return BLANK_ADDRESS;
    if (
      !profile.value.billing_address_line_1 &&
      !profile.value.billing_address_city &&
      !profile.value.billing_address_state &&
      !profile.value.billing_address_country_id &&
      !profile.value.billing_address_postal_code
    ) {
      return currentAddress.value;
    }
    return {
      street_address_1: profile.value.billing_address_line_1 ?? "",
      city: profile.value.billing_address_city ?? "",
      state: profile.value.billing_address_state ?? "",
      country: profile.value.billing_address_country_id ?? "",
      postal_code: profile.value.billing_address_postal_code ?? "",
    };
  });

  return {
    currentAddress,
    permanentAddress,
    billingAddress,
  };
};
